var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geodkobjekter"},_vm._l((_vm.geoDkObjekterToShow),function(item){return _c('GeoDkObjektListItem',{key:item.get('geoDkId'),attrs:{"item":item,"removeItem":_vm.removeItem}})}))}
var staticRenderFns = []

export { render, staticRenderFns }